shadow$provide[317] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, linear:{enumerable:true, get:function() {
  return linear;
}}, log:{enumerable:true, get:function() {
  return log;
}}, make:{enumerable:true, get:function() {
  return make;
}}});
const linear = function(min, max, n, unit, base, factor, start, end, zero, nice) {
  let ticks;
  let i, f;
  if (nice == null) {
    nice = true;
  }
  if (!n) {
    n = 10;
  }
  if (!unit) {
    unit = 1;
  }
  if (!base) {
    base = 10;
  }
  if (!factor) {
    factor = 1;
  }
  const span = max - min;
  const ideal = span / n;
  if (!nice) {
    ticks = (() => {
      let asc, end1;
      const result = [];
      for (i = 0, end1 = n, asc = 0 <= end1; asc ? i <= end1 : i >= end1; asc ? i++ : i--) {
        result.push(min + i * ideal);
      }
      return result;
    })();
    if (!start) {
      ticks.shift();
    }
    if (!end) {
      ticks.pop();
    }
    if (!zero) {
      ticks = ticks.filter(x => x !== 0);
    }
    return ticks;
  }
  if (!unit) {
    unit = 1;
  }
  if (!base) {
    base = 10;
  }
  const ref = unit * Math.pow(base, Math.floor(Math.log(ideal / unit) / Math.log(base)));
  const factors = base % 2 === 0 ? [base / 2, 1, 1 / 2] : base % 3 === 0 ? [base / 3, 1, 1 / 3] : [1];
  const steps = (() => {
    const result1 = [];
    for (f of Array.from(factors)) {
      result1.push(ref * f);
    }
    return result1;
  })();
  let distance = Infinity;
  let step = steps.reduce(function(ref, step) {
    f = step / ideal;
    const d = Math.max(f, 1 / f);
    if (d < distance) {
      distance = d;
      return step;
    } else {
      return ref;
    }
  }, ref);
  step *= factor;
  min = Math.ceil(min / step + +!start) * step;
  max = (Math.floor(max / step) - +!end) * step;
  n = Math.ceil((max - min) / step);
  ticks = (() => {
    let asc1, end2;
    const result2 = [];
    for (i = 0, end2 = n, asc1 = 0 <= end2; asc1 ? i <= end2 : i >= end2; asc1 ? i++ : i--) {
      result2.push(min + i * step);
    }
    return result2;
  })();
  if (!zero) {
    ticks = ticks.filter(x => x !== 0);
  }
  return ticks;
};
const log = function(_min, _max, _n, _unit, _base, _bias, _start, _end, _zero, _nice) {
  throw new Error("Log ticks not yet implemented.");
};
const LINEAR = 0;
const LOG = 1;
const make = function(type, min, max, n, unit, base, bias, start, end, zero, nice) {
  switch(type) {
    case LINEAR:
      return linear(min, max, n, unit, base, bias, start, end, zero, nice);
    case LOG:
      return log(min, max, n, unit, base, bias, start, end, zero, nice);
  }
};

};